<script setup lang="ts">
import { NText } from 'naive-ui'
import { useAttrs } from 'vue'

const props = withDefaults(defineProps<{
  type?: 'default' | 'primary' | 'info' | 'success' | 'warning' | 'error'
  depth?: 1 | 2 | 3
  strong?: boolean
  italic?: boolean
  underline?: boolean
  delete?: boolean
  code?: boolean
  keyboard?: boolean
  tag?: string
}>(), {
  type: 'default',
  depth: 1,
  strong: false,
  italic: false,
  underline: false,
  delete: false,
  code: false,
  keyboard: false,
  tag: 'span',
})

const attrs = useAttrs()
</script>

<template>
  <NText
    :type="type"
    :depth="depth"
    :strong="strong"
    :italic="italic"
    :underline="underline"
    :delete="delete"
    :code="code"
    :keyboard="keyboard"
    :tag="tag"
    v-bind="attrs"
  >
    <slot />
  </NText>
</template>

<style scoped>
/* Custom styles can be added here if needed */
</style>
